<template>
    <div class="box">
        <span class="version">version:{{ network.version }} device:{{ network.deviceId }}</span>
        <div class="purchase_box">
            <div class="leftBox">
                <div class="col">
                    <div class="top">
                        <img src="@/assets/visualization/purchase.svg" />
                        <div class="splitline"></div>
                        <div>
                            <span style="font-weight:bold">{{ purchase.count }}</span>
                            <span>笔</span>
                        </div>
                        <!-- <div>采购需求</div> -->
                    </div>
                    <div class="bottom">
                        <div>到货</div>
                        <!-- <div>未到/已到</div> -->
                    </div>
                </div>
            </div>
            <div class="rightBox">
                <div class="col">
                    <div class="top">
                        <div class="overdue">逾期</div>
                        <div class="firstBox red">
                            <span>{{ purchase.overdue && purchase.overdue.count }}</span>
                            <span>笔</span>
                        </div>
                        <div class="secondBox">
                            <div class="secondBox-text">
                                <span>{{ purchase.overdue && purchase.overdue.typeQuantity }}</span>
                                <span>SKU</span>
                            </div>
                        </div>
                        <div class="thirdBox">
                            <div>
                                <span>{{ formatNumber(purchase.overdue.quantity) }} </span>
                                <span> PCS</span>
                            </div>
                        </div>
                    </div>
                    <div class="splitline"></div>
                    <div class="bottom">
                        <div>
                            <div class="red-check-circle"></div>
                            <div>
                                <span>{{ purchase.overdue_complete && purchase.overdue_complete.count }}</span>
                                <span>笔</span>
                            </div>
                        </div>
                        <div>
                            <span>{{ purchase.overdue_complete && purchase.overdue_complete.typeQuantity }}</span>
                            <span>SKU</span>
                        </div>
                        <div>
                            <span>{{ purchase.overdue_complete && Math.round(purchase.overdue_complete.quantity)
                                }}</span>
                            <span> PCS</span>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="top">
                        <div class="overdue">本周</div>
                        <div class="firstBox">
                            <span>{{ purchase.this_week && purchase.this_week.count }}</span>
                            <span>笔</span>
                        </div>
                        <div class="secondBox">
                            <div class="secondBox-text">
                                <span>{{ purchase.this_week && purchase.this_week.typeQuantity }}</span>
                                <span>SKU</span>
                            </div>
                        </div>
                        <div class="thirdBox">
                            <div>
                                <span>{{ formatNumber(purchase.this_week.quantity) }} </span>
                                <span> PCS</span>
                            </div>
                        </div>
                    </div>
                    <div class="splitline"></div>
                    <div class="bottom">
                        <div>
                            <div class="blue-check-circle"></div>
                            <div>
                                <span>{{ purchase.this_week_complete && purchase.this_week_complete.count }}</span>
                                <span>笔</span>
                            </div>
                        </div>
                        <div>
                            <span>{{ purchase.this_week_complete && purchase.this_week_complete.typeQuantity }}</span>
                            <span>SKU</span>
                        </div>
                        <div>
                            <span>{{ purchase.this_week_complete && purchase.this_week_complete.quantity }}</span>
                            <span> PCS</span>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="top">
                        <div class="overdue">下周</div>
                        <div class="firstBox">
                            <span>{{ purchase.next_week && purchase.next_week.count }}</span>
                            <span>笔</span>
                        </div>
                        <div class="secondBox">
                            <div class="secondBox-text">
                                <span>{{ purchase.next_week && purchase.next_week.typeQuantity }}</span>
                                <span>SKU</span>
                            </div>
                        </div>
                        <div class="thirdBox">
                            <div>
                                <span>{{ formatNumber(purchase.next_week.quantity) }} </span>
                                <span> PCS</span>
                            </div>
                        </div>
                    </div>
                    <div class="splitline"></div>
                    <div class="bottom">
                        <div>
                            <div class="green-check-circle"></div>
                            <div>
                                <span>{{ purchase.next_week_complete && purchase.next_week_complete.count }}</span>
                                <span>笔</span>
                            </div>
                        </div>
                        <div>
                            <span>{{ purchase.next_week_complete && purchase.next_week_complete.typeQuantity }}</span>
                            <span>SKU</span>
                        </div>
                        <div>
                            <span>{{ purchase.next_week_complete && Math.round(purchase.next_week_complete.quantity)
                                }}</span>
                            <span> PCS</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="QC_box">
            <div class="leftBox">
                <div class="col">
                    <div class="top">
                        <img style="width:17vw;height:auto" src="@/assets/visualization/QC.svg" />
                        <div class="splitline"></div>
                        <div>
                            <span style="font-weight:bold">{{ iqc.count }}</span>
                            <span>笔</span>
                        </div>
                        <!-- <div>质检作业</div> -->
                    </div>
                    <div class="bottom">
                        <div>质检</div>
                        <!-- <div>待检/已检</div> -->
                    </div>
                </div>
            </div>
            <div class="rightBox">
                <div class="col">
                    <div class="overdue">待检</div>
                    <div class="firstBox blue">
                        <span>{{ iqc.not_complete && iqc.not_complete.count }}</span>
                        <span>笔</span>
                    </div>
                    <div class="secondBox">
                        <!-- <img src="@/assets/visualization/bs.svg" /> -->
                        <div class="secondBox-text">
                            <span>{{ iqc.not_complete && iqc.not_complete.typeQuantity }}</span>
                            <span>SKU</span>
                        </div>
                    </div>
                    <div class="thirdBox">
                        <div :style="{ 'padding-right': Math.round(iqc.not_complete.quantity).length > 7 ? '0px' : '20px' }">
                            <span>{{ iqc.not_complete && Math.round(iqc.not_complete.quantity) }} </span>
                            <span> PCS</span>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="overdue">已检(本周)</div>
                    <div class="firstBox green">
                        <span>{{ iqc.this_week_complete && iqc.this_week_complete.count }}</span>
                        <span>笔</span>
                    </div>
                    <div class="secondBox">
                        <!-- <img src="@/assets/visualization/bs.svg" /> -->
                        <div class="secondBox-text">
                            <span>{{ iqc.this_week_complete && iqc.this_week_complete.typeQuantity }}</span>
                            <span>SKU</span>
                        </div>
                    </div>
                    <div class="thirdBox">
                        <div
                            :style="{ 'padding-right': Math.round(iqc.this_week_complete.quantity).length > 7 ? '0px' : '20px' }">
                            <span>{{ iqc.this_week_complete && Math.round(iqc.this_week_complete.quantity) }} </span>
                            <span> PCS</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="warehousing_box QC_box">
            <div class="leftBox">
                <div class="col">
                    <div class="top">
                        <img style="width:17vw;height:auto" src="@/assets/visualization/warehousing.svg" />
                        <div class="splitline"></div>
                        <div>
                            <span style="font-weight:bold">{{ receipt.count }}</span>
                            <span>笔</span>
                        </div>
                        <!-- <div>入库作业</div> -->
                    </div>
                    <div class="bottom">
                        <div>入库</div>
                        <!-- <div>待入/已入</div> -->
                    </div>
                </div>
            </div>
            <div class="rightBox">
                <div class="col">
                    <div class="overdue">待入</div>
                    <div class="firstBox blue">
                        <span>{{ receipt.not_complete && receipt.not_complete.count }}</span>
                        <span>笔</span>
                    </div>
                    <div class="secondBox">
                        <!-- <img src="@/assets/visualization/bs.svg" /> -->
                        <div class="secondBox-text">
                            <span>{{ receipt.not_complete && receipt.not_complete.typeQuantity }}</span>
                            <span>SKU</span>
                        </div>
                    </div>
                    <div class="thirdBox">
                        <div :style="{ 'padding-right': Math.round(receipt.not_complete.quantity).length > 7 ? '0px' : '20px' }">
                            <span>{{ receipt.not_complete && Math.round(receipt.not_complete.quantity) }}</span>
                            <span> PCS</span>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="overdue">已入(本周)</div>
                    <div class="firstBox green">
                        <span>{{ receipt.this_week_complete && receipt.this_week_complete.count }}</span>
                        <span>笔</span>
                    </div>
                    <div class="secondBox">
                        <!-- <img src="@/assets/visualization/bs.svg" /> -->
                        <div class="secondBox-text">
                            <span>{{ receipt.this_week_complete && receipt.this_week_complete.typeQuantity }}</span>
                            <span>SKU</span>
                        </div>
                    </div>
                    <div class="thirdBox">
                        <div
                            :style="{ 'padding-right': Math.round(receipt.this_week_complete.quantity).length > 7 ? '0px' : '20px' }">
                            <span>{{ receipt.this_week_complete && Math.round(receipt.this_week_complete.quantity) }}
                            </span>
                            <span> PCS</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer">
            <div>
                <span style="font-size: 26px;">{{ dateweek.day }} {{ dateweek.week }}</span>
                <span class="mock-block">
                    <img class="icon" src="@/assets/visualization/calendar.svg" />
                </span>
            </div>
            <div>
                <span style="font-size: 20px;color: red;" v-if="network.msg">{{network.msg}}</span>
            </div>
            <div>
                <span style="font-size: 26px;">{{ dateweek.time }}</span>
                <span class="mock-block">
                    <img class="icon" src="@/assets/visualization/time.svg" />
                </span>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    props: {
        dateweek: {
            type: Object
        },
        network: {
            type: Object
        },
        payload: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            purchase: {
                count: '',
                overdue: {},
                overdue_complete: {},
                this_week: {},
                this_week_complete: {},
                next_week: {},
                next_week_complete: {},
            },
            iqc: {
                count: '',
                not_complete: {},
                this_week_complete: {},
            },
            receipt: {
                count: '12',
                not_complete: {},
                this_week_complete: {},
            },
        }
    },
    watch: {
        payload() {
            this.setpayload()
        }
    },
    created() {
        this.setpayload()
    },
    // 挂载时间
    methods: {
        setpayload() {
            this.payload.forEach(item => {
                    // 采购
                    if (item.requireType && item.requireType.value == 'PURCHASE') {
                        let purchaseArr = item.items
                        this.purchase.count = 0
                        purchaseArr.forEach((item) => {
                            //逾期未完成
                            if (item.dataType.value == 'OVERDUE') {
                                this.purchase.overdue = item
                            }
                            // 逾期本周已完成
                            if (item.dataType.value == "OVERDUE_COMPLETE") {
                                this.purchase.overdue_complete = item
                            }
                            // 本周未完成
                            if (item.dataType.value == "THIS_WEEK") {
                                this.purchase.this_week = item
                            }
                            // 本周完成
                            if (item.dataType.value == "THIS_WEEK_COMPLETE") {
                                this.purchase.this_week_complete = item
                            }
                            // 下周未完成
                            if (item.dataType.value == "NEXT_WEEK") {
                                this.purchase.next_week = item
                            }
                            // 下周已完成
                            if (item.dataType.value == "NEXT_WEEK_COMPLETE") {
                                this.purchase.next_week_complete = item
                            }
                            this.purchase.count += item.count
                        })
                    }
                    // 质检
                    if (item.requireType && item.requireType.value == 'IQC') {
                        let iqcArr = item.items
                        this.iqc.count = 0
                        iqcArr.forEach((item) => {
                            //未完成
                            if (item.dataType.value == "NOT_COMPLETE") {
                                this.iqc.not_complete = item
                            }
                            // 已完成
                            if (item.dataType.value == "THIS_WEEK_COMPLETE") {
                                this.iqc.this_week_complete = item
                            }
                            this.iqc.count += item.count
                        })
                    }
                    // 入库
                    if (item.requireType && item.requireType.value == 'RECEIPT') {
                        let receiptArr = item.items
                        this.receipt.count = 0
                        receiptArr.forEach((item) => {
                            //未完成
                            if (item.dataType.value == "NOT_COMPLETE") {
                                this.receipt.not_complete = item
                            }
                            // 已完成
                            if (item.dataType.value == "THIS_WEEK_COMPLETE") {
                                this.receipt.this_week_complete = item
                            }
                            this.receipt.count += item.count
                        })

                    }

                });
            
        },
        // 将数字转换w,kw单位
        formatNumber(number) {
            let num = number ? Math.round(number) : 0
            let result = ''
            if (num.toString().length > 5 && num.toString().length < 7) {
                result = (num / 1e4).toFixed(1) + 'w';
            } else if (num.toString().length >= 7) {
                result = (num / 1e7).toFixed(1) + 'kw';
            } else {
                result = num
            }
            return result
        },

    },
    beforeCreate() {
        document.getElementsByTagName('body')[0].style.margin = '0'
    },
}
</script>
<style scoped lang="less">
* {
    margin: 0;
    padding: 0;
}

.box {
    padding: 45px 0 0;
    background: white;
    //   width: calc(100vw - 10px);
    width: 100%;
    height: calc(100vh - 45px);
    overflow: hidden;

    .purchase_box {
        margin: 0 50px 30px;
        height: calc(32vh - 50px);
        // margin-bottom: 50px;
        display: flex;
        justify-content: space-between;
        border-radius: 10px;
        border: 5px solid #333333;
        box-sizing: border-box;

        .leftBox {
            width: 25%;
            border-radius: 6px 0 0 6px;
            text-align: center;
            border-right: 5px solid #333;
            box-sizing: border-box;

            .col {
                font-size: 2vh;
                height: 100%;

                .top {
                    height: 75%;

                    div {
                        span:nth-child(1) {
                            font-size: 4vh;
                        }
                    }

                    img {
                        width: 15vw;
                        height: auto;
                        margin: 2vh 0 0;
                        vertical-align: middle;
                    }

                    .splitline {
                        width: auto;
                        height: 5px;
                        margin: 2.5vh 22px 2.2vh;
                        background-color: #333;

                    }
                }

                .bottom {
                    height: 25%;
                    color: #FFFFFF;
                    background: #333;
                    border-radius: 0 0 0 5px;

                    div:first-child {
                        font-size: 5vh;
                        // line-height: 7.8vh;
                        height: 100%;
                    }

                    div:nth-child(2) {
                        font-size: 2vh;
                        line-height: 4.6vh;
                    }
                }
            }
        }

        .rightBox {
            width: 75%;
            display: flex;

            .col:nth-child(1),
            .col:nth-child(2),
            .col:nth-child(3) {
                color: #333;

                .top {
                    height: calc(21.4vh - 8px - 50px);
                    border-radius: 6px;
                    // padding: 0.5vh 30px;

                    .overdue {
                        color: #fff;
                        height: 4.17vh;
                        line-height: 4.17vh;
                        font-size: 2vh;
                        // padding-bottom: 20px;
                        // border-bottom: 1px solid rgba(255, 255, 255, 0.2);
                    }

                    .firstBox {
                        // background: rgba(255, 255, 255, 0.3);
                        border-radius: 6px;
                        text-align: right;
                        padding-right: 20px;
                        margin-top: 1.5vh;
                        // height: 58px;
                        height: 4vh;
                        font-weight: bold;

                        span {
                            // font-size: 50px;
                            // line-height: 1;
                            font-size: 4vh;
                            line-height: 4vh;
                        }

                        span:nth-child(2) {
                            font-size: 2vh // font-size: 26px;
                                // line-height: 1;
                        }

                    }

                    .secondBox {
                        // background: rgba(255, 255, 255, 0.3);
                        border-radius: 6px;
                        // margin-top: 1vh;
                        // padding: 0px 12px 5px 12px;
                        display: flex;
                        justify-content: flex-end;
                        align-items: center;
                        padding: 0px 20px;

                        // img {
                        //     width: 2vh;
                        //     height: 2vh,
                        // }

                        .secondBox-text {
                            // display: inline-block;
                            // float: right;
                            // font-size: 30px;
                            font-size: 3vh;

                            span:nth-child(2) {
                                font-size: 1.5vh;
                            }
                        }
                    }

                    .thirdBox {
                        // margin-top: 1vh;
                        // background: rgba(255, 255, 255, 0.3);
                        border-radius: 6px;
                        padding-right: 20px;
                        // font-size: 30px;

                        text-align: right;

                        div {
                            span:first-child {
                                font-size: 2.5vh;
                            }

                            span:nth-child(2) {
                                font-size: 1.5vh;
                            }
                        }
                    }
                }

                .splitline {
                    width: auto;
                    height: 2px;
                    margin: 0 18px 2vh;
                    background-color: #333;
                }

                .bottom {
                    color: #333;
                    border-radius: 6px;
                    padding: 0px 20px 0 40px;
                    line-height: 2.1vh;

                    div:nth-child(1) {
                        display: flex;
                        justify-content: space-between;
                        // font-weight: bold;
                        align-items: center;
                        // font-size: 2.5vh;
                        // line-height: 4.6vh;

                        img {
                            width: 2vw;
                            height: 2vh,
                        }

                        div {
                            span:first-child {
                                font-size: 2.5vh;
                            }

                            span:nth-child(2) {
                                font-size: 1.5vh;
                            }
                        }
                    }

                    div:nth-child(2) {
                        font-size: 2vh;

                        span:nth-child(2) {
                            font-size: 1.2vh;
                        }
                    }

                    div:nth-child(3) {
                        span:first-child {
                            font-size: 1.5vh;
                        }

                        span:nth-child(2) {
                            font-size: 1vh;
                        }
                    }

                    div:nth-child(2),
                    div:nth-child(3) {
                        text-align: right;
                    }

                }

            }

            .col {
                width: calc((100vw - 25vw - 40px) / 3 - 15px);
            }

            .col:not(:last-child) {
                border-right: 5px solid #333;
            }

            .col:nth-child(1) .top {

                // background: #F56C6C;
                .overdue {
                    background-color: #FA5151;
                }
            }

            .col:nth-child(2) .top {

                // background: #1890FF;
                .overdue {
                    background-color: #1890FF;
                }
            }

            .col:nth-child(3) .top {

                // background: #52C41A;
                .overdue {
                    background-color: #00B578;
                    border-radius: 0 5px 0 0;
                }
            }

            .col:nth-child(3) .bottom {
                // background: #EEFAE9;
                // border: 2px solid #52C41A;
                // color: #52C41A;
            }

            .col:nth-child(2) .bottom {
                // background: #E8F4FF;
                // border: 2px solid #1890FF;
                // color: #1890FF;
            }

            .col:nth-child(1) .bottom {
                // background: #FEF1F1;
                // border: 2px solid #F56C6C;
                // color: #F56C6C;
            }
        }

        .red-check-circle {
            width: 30px;
            height: 30px;
            border-radius: 50%;
            background-color: rgba(250, 81, 81, 0.7);
            display: flex;
            justify-content: center;
            align-items: center;
        }

        .red-check-circle::before {
            content: "";
            display: block;
            width: 14px;
            height: 8px;
            border: 3px solid #fff;
            border-right: none;
            border-top: none;
            transform: rotate(-45deg) translate(6px, 3px);
        }

        .blue-check-circle {
            width: 30px;
            height: 30px;
            border-radius: 50%;
            background-color: rgba(24, 144, 255, 0.7);
            display: flex;
            justify-content: center;
            align-items: center;
        }

        .blue-check-circle::before {
            content: "";
            display: block;
            width: 14px;
            height: 8px;
            border: 3px solid #fff;
            border-right: none;
            border-top: none;
            transform: rotate(-45deg) translate(6px, 3px);
        }

        .green-check-circle {
            width: 30px;
            height: 30px;
            border-radius: 50%;
            background-color: rgba(0, 181, 120, 0.7);
            display: flex;
            justify-content: center;
            align-items: center;
        }

        .green-check-circle::before {
            content: "";
            display: block;
            width: 14px;
            height: 8px;
            border: 3px solid #fff;
            border-right: none;
            border-top: none;
            transform: rotate(-45deg) translate(6px, 3px);
        }
    }

    .QC_box {
        // height: 32vh;
        margin: 0 50px 30px;
        height: calc(32vh - 50px);
        // margin-bottom: 50px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-radius: 10px;
        border: 5px solid #333333;
        box-sizing: border-box;

        .leftBox {
            width: 25%;
            border-radius: 6px 0 0 6px;
            // text-align: center;
            border-right: 5px solid #333;
            box-sizing: border-box;
            height: 100%;

            .col {
                height: 100%;
                // margin-left: 30px;
                font-size: 1.5vh;

                .top {
                    height: 75%;
                    text-align: center;

                    div {
                        span:nth-child(1) {
                            // font-size: 50px;
                            font-size: 4vh;
                        }
                    }

                    img {
                        margin: 2vh 0 0;
                        vertical-align: middle;
                    }

                    .splitline {
                        width: auto;
                        height: 5px;
                        margin: 2.5vh 22px 2.2vh;
                        background-color: #333;
                    }
                }

                .bottom {
                    // width: 22vw;
                    width: calc(25vw - 30px);
                    height: 25%;
                    background: #000000;
                    border-radius: 0 0 0 6px;
                    text-align: center;
                    color: #FFFFFF;

                    div:first-child {
                        font-size: 5vh;
                        height: 100%;
                    }

                    div:nth-child(2) {
                        font-size: 2vh;
                    }
                }
            }
        }

        .rightBox {
            width: 75%;
            height: 100%;
            display: flex;
            justify-content: space-between;

            .col {
                color: #333;
                // border-radius: 6px;
                // padding: 0.5vh 30px;
                width: 50%;
                box-sizing: border-box;

                .overdue {
                    color: #fff;
                    font-size: 2vh;
                    height: 4.17vh;
                    line-height: 4.17vh;
                    // padding-bottom: 20px;
                    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
                }

                .firstBox {
                    // background: rgba(255, 255, 255, 0.3);
                    border-radius: 6px;
                    text-align: right;
                    padding-right: 20px;
                    margin-top: 1.5vh;
                    // height: 58px;
                    height: 9vh;

                    span {
                        font-size: 8vh;
                        // font-size: 50px;
                        line-height: 1;
                    }

                    span:nth-child(2) {
                        // font-size: 26px;
                        font-size: 3vh;
                        line-height: 1;
                    }

                }

                .secondBox {
                    // background: rgba(255, 255, 255, 0.3);
                    border-radius: 6px;
                    margin-top: 1vh;
                    // padding: 0px 12px 5px 12px;
                    padding: 0px 20px;
                    height: 6vh;
                    display: flex;
                    align-items: center;
                    justify-content: flex-end;

                    // img {
                    //     // width: 20%;
                    //     // height: 20%,
                    //     width: 4vh;
                    // }

                    .secondBox-text {
                        // display: inline-block;
                        // float: right;
                        // font-size: 30px;
                        font-size: 3vh;

                        span:nth-child(2) {
                            font-size: 2vh;
                        }
                    }
                }

                .thirdBox {
                    margin-top: 1vh;
                    // background: rgba(255, 255, 255, 0.3);
                    border-radius: 6px;
                    // padding-right: 20px;
                    // font-size: 30px;
                    // font-size: 2vh;
                    text-align: right;
                    height: 4vh;
                    line-height: 4vh;

                    div {
                        span:first-child {
                            font-size: 3vh;
                        }

                        span:nth-child(2) {
                            font-size: 2vh;
                        }
                    }
                }

            }

            .col:nth-child(1) {
                // background: #F56C6C;
                border-right: 5px solid #333;

                // box-sizing: border-box;
                .overdue {
                    background-color: #1890FF;
                }

            }

            .col:nth-child(2) {
                border-radius: 0 5px 5px 0;

                .overdue {
                    background-color: #00B578;
                }
            }

        }

        // .col:nth-child(2),
        // .col:nth-child(3) {
        //     color: #FFFFFF;
        //     border-radius: 6px;
        //     padding: 0.5vh 30px;
        //     width: calc(39vw - 4vw);

        //     .overdue {
        //         font-size: 1.8vh;
        //         // padding-bottom: 20px;
        //         border-bottom: 1px solid rgba(255, 255, 255, 0.2);
        //     }

        //     .firstBox {
        //         // background: rgba(255, 255, 255, 0.3);
        //         border-radius: 6px;
        //         color: #FFFFFF;
        //         text-align: right;
        //         padding-right: 12px;
        //         margin-top: 1.5vh;
        //         // height: 58px;
        //         height: 9vh;

        //         span {
        //             font-size: 8vh;
        //             // font-size: 50px;
        //             line-height: 1;
        //         }

        //         span:nth-child(2) {
        //             // font-size: 26px;
        //             font-size: 3vh;
        //             line-height: 1;
        //         }

        //     }

        //     .secondBox {
        //         // background: rgba(255, 255, 255, 0.3);
        //         border-radius: 6px;
        //         margin-top: 1vh;
        //         // padding: 0px 12px 5px 12px;
        //         padding: 0px 12px;
        //         height: 6vh;
        //         display: flex;
        //         align-items: center;
        //         justify-content: flex-end;

        //         // img {
        //         //     // width: 20%;
        //         //     // height: 20%,
        //         //     width: 4vh;
        //         // }

        //         .secondBox-text {
        //             // display: inline-block;
        //             // float: right;
        //             // font-size: 30px;
        //             font-size: 3vh;
        //         }
        //     }

        //     .thirdBox {
        //         margin-top: 1vh;
        //         // background: rgba(255, 255, 255, 0.3);
        //         border-radius: 6px;
        //         padding-right: 12px;
        //         // font-size: 30px;
        //         font-size: 2vh;
        //         text-align: right;
        //         height: 4vh;
        //         line-height: 4vh;
        //     }

        // }

        // .col:nth-child(2) {
        //     background: #F56C6C;
        // }

        // .col:nth-child(3) {
        //     background: #1890FF;
        // }

        // .col:first-child {
        //     margin-left: 0px;
        //     width: calc(25vw - 30px);
        // }
    }

    .warehousing_box {
        // height: 32vh;
        height: calc(32vh - 50px);
        margin-bottom: 35px;
    }

    .footer {
        height: 4vh;
        background: #D0E9FF;
        padding: 5px 40px 5px 20px;
        color: #606266;
        display: flex;
        justify-content: space-between;

        div {
            display: flex;
            align-items: center;

            .icon {
                width: 30px;
                height: auto;
                vertical-align: middle;
                margin: 0 0 0 20px;
            }
        }

    }

    .red {
        color: #FA5151;
    }

    .blue {
        color: #1890FF;
    }

    .green {
        color: #00B578;
    }
}
.version{
    font-size:20px;
    position: absolute;
    left: 0px;
    top: 10px;
    color:rgba(0, 0, 0, 0.3)
}
</style>



// WEBPACK FOOTER //
// src/views/warehouse/Incoming.vue